module.exports = __webpack_public_path__ + "static/media/Cartela_V.ac32cf73.svg";